// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tooltip__M\\+Lti {
  position: relative;
  display: inline-block;
  margin: 0 4px;
}

.styles_tooltip__M\\+Lti > div {
  display: flex;
}

.styles_tooltip__M\\+Lti .styles_tooltiptext__PTRWu {
  visibility: hidden;
  width: 60px;
  background-color: rgba(27, 27, 27, 0.9);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1001;
  margin-right: -30px;
  box-sizing: border-box;
  right: 67%;
}

.styles_tooltip__M\\+Lti .styles_tooltiptext__PTRWu::after {
  content: "";
  position: absolute;
  top: -10px;
  left: 50%;
  margin-right: -5px;
  border-width: 5px;
  border-style: solid;
  transform: rotate(180deg);
  border-color: rgba(27, 27, 27, 0.9) transparent transparent transparent;
}

.styles_tooltip__M\\+Lti:hover .styles_tooltiptext__PTRWu {
  visibility: visible;
}

@media only screen and (max-width: 800px) {
  .styles_tooltip__M\\+Lti .styles_tooltiptext__PTRWu {
    right: 20%;
    display: none;
  }
  .styles_tooltip__M\\+Lti .styles_tooltiptext__PTRWu::after {
    left: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/TooltipBottom/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;AACF;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,uCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EAGA,mBAAA;EACA,sBAAA;EAEA,UAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uEAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE;IACE,UAAA;IACA,aAAA;EAHF;EAMA;IACE,SAAA;EAJF;AACF","sourcesContent":[".tooltip {\n  position: relative;\n  display: inline-block;\n  margin:0 4px;\n  // cursor: pointer;\n}\n\n.tooltip > div {\n    display: flex;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 60px;\n  background-color: rgba(27, 27, 27, 0.9);\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1001;\n  // top: 150%;\n  // right: 50%;\n  margin-right: -30px;\n  box-sizing: border-box;\n  // right: 50%;\n  right: 67%;\n}\n\n.tooltip .tooltiptext::after {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  margin-right: -5px;\n  border-width: 5px;\n  border-style: solid;\n  transform: rotate(180deg);\n  border-color: rgba(27, 27, 27, 0.9) transparent transparent transparent;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n@media only screen and (max-width: 800px) {\n  .tooltip .tooltiptext {\n    right: 20%;\n    display: none;\n  }\n\n  .tooltip .tooltiptext::after {\n    left: 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `styles_tooltip__M+Lti`,
	"tooltiptext": `styles_tooltiptext__PTRWu`
};
export default ___CSS_LOADER_EXPORT___;
